module.exports = __webpack_public_path__ + "static/media/BillionDollarGirlBookCover.1f041ff0.jpg";